import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
const roundToSingleDecimal = (value) => {
    return Math.round(value * 10) / 10;
};
export const NcDaysComparison = ({ options, previousQuarterLabel }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [hasResult, setHasResult] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [totalNcDays, setTotalNcDays] = useState(null);
    const [previousQuarterNcDays, setPreviousQuarterNcDays] = useState(null);
    useEffect(() => {
        if (!options.isReady) {
            setHasResult(false);
            setIsLoading(false);
            setErrorMessage("");
            setTotalNcDays(null);
            setPreviousQuarterNcDays(null);
            return;
        }
        setIsLoading(true);
        setHasResult(false);
        setErrorMessage("");
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/quarterly?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setHasResult(true);
            if (data === null) {
                setTotalNcDays(null);
                setPreviousQuarterNcDays(null);
                return;
            }
            setTotalNcDays(data.TotalNcDays);
            setPreviousQuarterNcDays(data.PreviousQuarterNcDays);
        })
            .catch((error) => {
            console.error(error);
            setErrorMessage("Error fetching NC days data");
        })
            .finally(() => setIsLoading(false));
    }, [options.isReady, options.year, options.quarter, options.fleetIds]);
    const delta = totalNcDays === null || previousQuarterNcDays === null
        ? null
        : roundToSingleDecimal(totalNcDays - previousQuarterNcDays);
    const deltaPercentage = previousQuarterNcDays === null || previousQuarterNcDays === 0 || totalNcDays === null
        ? null
        : roundToSingleDecimal(((totalNcDays - previousQuarterNcDays) / previousQuarterNcDays) * 100);
    const deltaClass = delta === null ? "text-muted" : delta > 0 ? "text-danger" : delta < 0 ? "text-success" : "text-muted";
    const deltaIcon = delta === null ? "" : delta > 0 ? "▲" : delta < 0 ? "▼" : "";
    const deltaPercentageDisplay = deltaPercentage === null ? "N/A" : `${Math.abs(deltaPercentage)}%`;
    const comparisonLabel = previousQuarterLabel?.() ?? "previous quarter";
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "Total NC Days" }), _jsxs("div", { className: "card-body d-flex flex-column", children: [(!options.isReady || isLoading) && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), options.isReady && hasResult && !isLoading && totalNcDays === null && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." })), options.isReady && hasResult && !isLoading && (_jsx("div", { className: "mt-auto", children: totalNcDays !== null && (_jsxs(_Fragment, { children: [_jsx("h1", { className: "mb-1", children: totalNcDays }), _jsxs("p", { className: `mb-0 ${deltaClass}`, children: [_jsx("span", { children: deltaIcon }), deltaIcon ? " " : "", _jsx("span", { children: deltaPercentageDisplay }), ` vs ${comparisonLabel}`] })] })) }))] })] }));
};
